<template>
    <div class="mi-cuenta">
        <h1>Mi Cuenta</h1>
        
        <div v-if="loading" class="loading">
            <div class="spinner"></div>
            <p>Cargando datos...</p>
        </div>
        
        <div v-else-if="error" class="error">
            {{ error }}
        </div>
        
        <div v-else class="user-card">
            <div class="card-header">
                <img :src="user.avatar || require('@/assets/images/user/users35x35.png')" alt="avatar" class="avatar" />
                <h2>{{ fullName }}</h2>
            </div>
            
            <div class="card-body">
                <div class="card-item">
                    <label>Nombre:</label>
                    <p>{{ user.first_name || 'No especificado' }}</p>
                </div>
                <div class="card-item">
                    <label>Apellido:</label>
                    <p>{{ user.last_name || 'No especificado' }}</p>
                </div>
                <div class="card-item">
                    <label>Usuario:</label>
                    <p>{{ user.username }}</p>
                </div>
                <div class="card-item">
                    <label>Email:</label>
                    <p>{{ user.email }}</p>
                </div>
                <div class="card-item">
                    <label>ID:</label>
                    <p>{{ user.id }}</p>
                </div>
                <div class="card-item">
                    <label>Super Usuario:</label>
                    <p>{{ user.is_superuser ? 'Sí' : 'No' }}</p>
                </div>
                <div class="card-item">
                    <label>Staff:</label>
                    <p>{{ user.is_staff ? 'Sí' : 'No' }}</p>
                </div>
                <div class="card-item" v-if="user.groups && user.groups.length > 0">
                    <label>Grupos:</label>
                    <p>{{ user.groups.join(', ') }}</p>
                </div>
                <div class="card-item" v-if="user.permissions">
                    <label>Permisos:</label>
                    <ul class="permissions-list">
                        <li v-if="user.permissions.can_access_admin">
                            <i class="fa fa-check"></i> Acceso Admin
                        </li>
                        <li v-if="user.permissions.can_edit">
                            <i class="fa fa-check"></i> Puede Editar
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/axios";
import authService from '@/services/authService';

export default {
    name: 'MiCuenta',
    data() {
        return {
            user: {},
            loading: true,
            error: null
        }
    },
    computed: {
        fullName() {
            if (!this.user) return '';
            const firstName = this.user.first_name || '';
            const lastName = this.user.last_name || '';
            return firstName && lastName ? `${firstName} ${lastName}` : this.user.username || '';
        }
    },
    mounted() {
        this.fetchUserData()
    },
    methods: {
        async fetchUserData() {
            try {
                this.loading = true;
                this.error = null;
                
                // Axios devuelve los datos en response.data
                const response = await api.get('me/');
                
                if (response.data) {
                    this.user = response.data;
                    // Actualizar los datos en authService
                    authService.setUserData(response.data);
                    console.log('Datos del usuario cargados:', this.user);
                } else {
                    this.error = 'No se recibieron datos del usuario';
                }
            } catch (err) {
                console.error('Error al cargar datos del usuario:', err);
                
                if (err.response) {
                    // Error de respuesta del servidor
                    if (err.response.status === 401) {
                        this.error = 'Sesión expirada. Por favor, inicia sesión nuevamente.';
                        setTimeout(() => {
                            this.$router.push('/auth/login');
                        }, 2000);
                    } else {
                        this.error = `Error del servidor: ${err.response.status}`;
                    }
                } else if (err.request) {
                    // Error de conexión
                    this.error = 'No se pudo conectar con el servidor';
                } else {
                    this.error = err.message || 'Error al cargar datos';
                }
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style scoped>
.mi-cuenta {
    padding: 20px;
    max-width: 800px;
    margin: 0 auto;
}

.mi-cuenta h1 {
    color: #09377c;
    margin-bottom: 30px;
    font-size: 28px;
    font-weight: 600;
}

.user-card {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.card-header {
    background: linear-gradient(135deg, #09377c 0%, #1e59a2 100%);
    padding: 30px;
    text-align: center;
    color: white;
}

.avatar {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 4px solid white;
    margin-bottom: 15px;
    object-fit: cover;
}

.card-header h2 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
}

.card-body {
    padding: 30px;
}

.card-item {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #f0f0f0;
}

.card-item:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
}

.card-item label {
    font-weight: 600;
    color: #09377c;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: block;
    margin-bottom: 8px;
}

.card-item p {
    margin: 0;
    color: #555;
    font-size: 16px;
}

.permissions-list {
    list-style: none;
    padding: 0;
    margin: 8px 0 0 0;
}

.permissions-list li {
    padding: 8px 0;
    color: #555;
    font-size: 16px;
}

.permissions-list i {
    color: #4caf50;
    margin-right: 8px;
}

.loading {
    padding: 60px 20px;
    text-align: center;
}

.spinner {
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #09377c;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.loading p {
    color: #666;
    font-size: 16px;
}

.error {
    padding: 20px;
    text-align: center;
    color: #d32f2f;
    background: #ffebee;
    border-radius: 8px;
    border: 1px solid #ef9a9a;
    font-size: 16px;
}
</style>